import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config.js';

const config = resolveConfig(tailwindConfig);

export const remToPixels = (rem) => {
    if (typeof rem === 'string') {
        rem = parseFloat(rem);
    }
    return (
        rem * (
            parseFloat(
                getComputedStyle(document.documentElement).fontSize
            )
        )
    );
};

export const breakpoints = (() => (
    Object.keys(config.theme.screens).reduce(
        (breakpoints, breakpoint) => ({
            ...breakpoints,
            [breakpoint]: (
                config.theme.screens[breakpoint].includes('px')
                    ? parseFloat(config.theme.screens[breakpoint])
                    : remToPixels(config.theme.screens[breakpoint])
            )
        }),
        {}
    )
))();

export const debounce = function (func, wait) {
  let timeout = null;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(
      () => func.apply(context, args),
      wait
    );
  };
};

export const throttle = function (func, delay) {
    let timeout = null;
    return function (...args) {
        if(timeout) return;
        func(...args);
        timeout = setTimeout(
            () => timeout = null,
            delay
        );
    };
};

